import { t } from "i18next";
import { get } from "react-hook-form";

export default function inputsValidation(errors: any, inputName: string): string {
  if (get(errors, inputName)) {
    switch (get(errors, inputName).type) {
      case "required":
        return t("to_pole_jest_wymagane");
      case "pattern":
        return get(errors, inputName).message;
      default:
        return get(errors, inputName).message ? get(errors, inputName).message : t("blednie_wypelnione_pole");
    }
  }
  return "";
}
